import { useGetProspectSignalsQuery } from "@/pages/Private/redux/signal/signal.api";
import { TrackerSignalResult } from "@/pages/Private/pages/ProfileTracker/schema/trackerSignalResult";

/**
 * The single latest signal for a prospect (the Recent box preview). Follows the signal domain's
 * existing pattern of consuming the RTK query hook directly (that domain has no Redux slice — see
 * `SignalTimeline`). Skipped unless the lead is on the Profile Tracker, mirroring the mockup where
 * signals only surface for tracked leads (so toggling tracking reveals them live).
 */
export const useLatestProspectSignal = (
	prospectId?: number,
	enabled = true
): { signal: TrackerSignalResult | null; isFetching: boolean } => {
	const { data, isFetching } = useGetProspectSignalsQuery(
		// Signals only: the timeline endpoint also returns list appearances (PREC-2496), and one of
		// those in the single slot this box reads would blank the preview.
		{ prospectId: prospectId ?? 0, page: 1, limit: 1, includeListAppearances: false },
		{ skip: !enabled || !prospectId }
	);

	return { signal: data?.data?.[0]?.signal ?? null, isFetching };
};
